import React from 'react';

import { Layout } from 'antd';

import { getLayoutMode } from '#/util/router';
import userInfo from '#/util/userInfo';
import { RouterContext } from '../../context';
import { canShowTopBarMode } from '../../../common/constant';

import Sidebar from './components/AdsSidebar';
import Header from './components/AdsHeader';
import Content from '../common/Content';
import './index.scss';

const AdsLayout = ({ systemConfig, state, dispatch, ...props }) => (
  <div className="ads-layout-main-wrap">
    <Layout className="wkd-layout-main">
      <RouterContext.Provider value={[state, dispatch]}>
        {/* todo  login logic remove */}
        {canShowTopBarMode.includes(getLayoutMode(systemConfig.curPageConfig)) && userInfo.isLogged() ? (
          <Header {...props} {...state} />
        ) : null}
        <Layout className="wkd-layout-container ads-wkd-layout-container" id="wkd-layout-container">
          <div className={'ads-content-wrapper'}>
            <Sidebar />
            <Content />
          </div>
        </Layout>
      </RouterContext.Provider>
    </Layout>
  </div>
);

export default AdsLayout;
